
<template>
  <CreateOrderTransferPromo office-type="stockist" use-origin-warehouse :index-route="{ name: 'penjualan.kirim-barang-promo.ke-stockist' }" />
</template>

<script>
import CreateOrderTransferPromo from '../../../../../components/order/create-order-transfer-promo.vue';

export default {
  components: {
    CreateOrderTransferPromo
  }
}
</script>